/**
 * Returns whether the (current) user is a premium (gold) member
 * @param {myProfile} myProfile { vip, gold, trialGoldExpirationDate }
 * @return {Boolean} isGold
 */
export const isGold = me => me.gold || me.vip || new Date().getTime() < me.trialGoldExpirationDate

/**
 * Returns whether the (current) user can upgrade further (gold or vip if enabled)
 * @param {store} store
 * @param {myProfile} store.myProfile { vip, gold }
 * @param {Object} store.flags { vip : bool }
 * @return {Boolean} canUpgrade
 */
export const canUpgrade = ({ myProfile, flags }) => !isGold(myProfile) || (flags.vip && !myProfile?.vip)

/**
 * Returns the zodiac of the user (first member)
 * @param {userProfile} user
 * @param zodiacs from registry
 * @return zodiac string
 */
export const getZodiac = (user, zodiacs) => {
  const id = user.members?.[0].zodiacId + 1
  return zodiacs.find(z => z.id == id)?.name
}

export const getSex = ({ sexId, members, sex }, source) => {
  if (/flirt|notifications/.test(source)) {
    return sexId
  }
  return members?.[0].sexOfMemberId || sex?.id
}

export const getMedia = (user, source, index) => {
  if (source == 'notifications') {
    return user.media
  }
  if (source == 'flirt') {
    return { accessType: user.mediaAccessType, adultRating: user.mediaAdultRating, uri: user.mediaPreviewUrl }
  }
  index = typeof index == 'number' ? index : user.media?.findIndex(e => e.isDefault)
  return user.media?.[index == -1 ? 0 : index] || {}
}

export const cookie = {
  get: (key, def) => JSON.parse(cookie.getBasic(key, 'null')) || def,
  getBasic: (key, def) => document.cookie.match(new RegExp(`${key}=([^\\s;]+)`))?.[1] || def,
  setBasic: (key, value, expires) =>
    (document.cookie = `${key}=${value};${!expires ? '' : `expires=${expires}; `} path=/; SameSite=Lax;`),
  set: (key, value, timeout) => cookie.setBasic(key, JSON.stringify(value), timeout && new Date(Date.now() + timeout)),
  reset: key => (document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT`), //don't need reset atm as upgrade is moved outside
}
